module.exports = __webpack_public_path__ + "static/media/b2_p5_crystal.dce78b21.mp3";